/**
 * Устойчивое хранилище.
 *
 * Два уровня: сырые строки (токены, идентификаторы) и JSON-значения.
 * Разделены намеренно — токен, случайно прошедший через JSON.stringify,
 * ломает заголовок Authorization незаметным образом.
 *
 * В фиче 1 сюда переезжает IndexedDB и очередь отправки; экраны,
 * использующие этот модуль, менять не придётся.
 */

// ── Сырые строки, живут между сессиями ──────────────────────
export const getRaw = (key) => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export const setRaw = (key, value) => {
  try {
    localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export const removeRaw = (key) => {
  try {
    localStorage.removeItem(key)
  } catch {
    /* приватный режим Safari запрещает запись — молча продолжаем */
  }
}

// ── Сырые строки, живут до закрытия вкладки ─────────────────
export const getSession = (key) => {
  try {
    return sessionStorage.getItem(key)
  } catch {
    return null
  }
}

export const setSession = (key, value) => {
  try {
    sessionStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export const removeSession = (key) => {
  try {
    sessionStorage.removeItem(key)
  } catch {
    /* см. выше */
  }
}

// ── JSON-значения ───────────────────────────────────────────
export const get = (key) => {
  const raw = getRaw(key)
  if (raw === null) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export const set = (key, value) => setRaw(key, JSON.stringify(value))

export const remove = removeRaw

/** Оценка занятого места. Нужна для политики квот в фиче 1. */
export async function estimate() {
  return (await globalThis.navigator?.storage?.estimate?.()) ?? { usage: 0, quota: 0 }
}
